import { render, staticRenderFns } from "./flowStatus.vue?vue&type=template&id=40d88cb0&scoped=true"
import script from "./flowStatus.vue?vue&type=script&lang=js"
export * from "./flowStatus.vue?vue&type=script&lang=js"
import style0 from "./flowStatus.vue?vue&type=style&index=0&id=40d88cb0&prod&lang=less&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d88cb0",
  null
  
)

export default component.exports